import React, { useEffect, useState } from 'react';
import { cotizadorDefault } from '../data/cotizadorCrData';
import useToken from '../hooks/useToken';
import http from '../services/http';
import { endPoints } from '../utils/constanst';

export const CotizadorCRDataContext = React.createContext(cotizadorDefault);
CotizadorCRDataContext.displayName = "CotizadorCRDataContext";

const CotizadorCRProvider = ({ loading, children }) => {
    const [cotizador, setCotizador] = useState({
        ...cotizadorDefault, 
        poliza: {
            ...cotizadorDefault.poliza,
            pais:'506',
            paisConyuge:'506'
        }
    });



    useEffect(() => {

        setCotizador({
            ...cotizador,
            'setPoliza': setPoliza,
            'setTarificacion': setTarificacion,
            'setCatalogos': setCatalogos,
            'polizaChangeHandler': polizaChangeHandler,
            'tarificacionChangeHandler': tarificacionChangeHandler,
            init: true
        });

    }, [cotizador.init]);


    const setPoliza = (obj) => setCotizador(prev => { return { ...prev, poliza: { ...prev.poliza, ...obj } }; });
    const setTarificacion = (obj) => setCotizador(prev => { return { ...prev, tarificacion: { ...prev.tarificacion, ...obj } }; });
    const setCatalogos = (obj) => setCotizador(prev => { return { ...prev, catalogos: { ...prev.catalogos, ...obj } }; });



    const polizaChangeHandler = event => {
        setPoliza({ [event.target.name]: event.target.value });
    }

    const tarificacionChangeHandler = event => {
        setTarificacion({ [event.target.name]: event.target.value });
    }



    return (
        <CotizadorCRDataContext.Provider value={cotizador}>
            {children}
        </CotizadorCRDataContext.Provider>
    );
}

export default CotizadorCRProvider;
